import { ActionType } from '../action';
import { SET_CHART_LIST, SET_IS_IN_IFRAME } from '../action/constants';
import { ChartPage } from '../types/chartPage';

const initState: ChartPage = {
  chartName: 'xxxxx',
  isInIframe: true,
};

export default (state: ChartPage = initState, action: ActionType): ChartPage => {
  let res: ChartPage = { ...state };
  if (action.type === SET_CHART_LIST) {
    res = {
      ...state,
      chartName: 'resetChartName',
    };
  } else if (action.type === SET_IS_IN_IFRAME) {
    res = {
      ...state,
      isInIframe: action.isInIframe,
    };
  }
  return res;
};
